import IconBlocks from '@/assets/icons/lucide/blocks.svg?react';
import { EKeyCode } from '@/enums/e_key_code';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { Key } from '@/enums/key';
import { use_slice_ui, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BUTTON__navigation_desktop } from '../desktop/BUTTON__navigation_desktop';
import { ButtonNavigationMobile } from '../mobile/ButtonNavigationMobile';
import { PROPS__button_navigation } from './PROPS__button_navigation';

export function ButtonNavigationOpenPose() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { global_is_mobile, global_need_show_first_animation } = use_slice_ui(['global_is_mobile', 'global_need_show_first_animation']);
  const { is_authorized } = use_slice_user(['is_authorized']);
  const { workspace_current, current_workspace_user } = use_slice_workspace(['workspace_current', 'current_workspace_user']);

  const is_visible = useMemo(() => get_is_visible(), [current_workspace_user, workspace_current]);

  const shortcut_key = Key.T;
  const shortcut_key_codes = [EKeyCode.T];

  /*
   * METHODS
   */

  function get_is_visible() {
    let user_permitted_to_view_entities = true;

    return user_permitted_to_view_entities && is_authorized;
  }

  /*
   * HTML
   */

  let props: PROPS__button_navigation = {
    global_need_show_first_animation,
    page_type: ENUM__page_type.OPEN_POSE_WITHOUT_PARAMS,
    tooltip_title: 'Open Pose',
    title: 'Open Pose',
    Icon: IconBlocks,
  };

  if (!is_visible) return null;

  return global_is_mobile ? <ButtonNavigationMobile {...props} /> : <BUTTON__navigation_desktop {...props} {...{ shortcut_key_codes }} />;
}
